import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const CancellationPolicy = () => {
    const { translateSync } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Cancellation Policy | Colours Boutique</title>
                <meta name="description" content="Read the Colours Boutique cancellation policy for saree orders, cancellation timelines, and refund processing." />
                <link rel="canonical" href="https://coloursboutique.com/cancellation-policy" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Cancellation Policy')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Cancellation Policy')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('Before Dispatch')}</h3>
                                            <p className="mb-0">
                                                {translateSync('You may request to cancel your saree order within 6 hours of purchase or before it has been handed over to the courier service (whichever comes first). Once an order is processed for shipment or handed to a shipping partner, cancellations are not possible.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('Customized Orders')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Saree orders that include custom blouse tailoring, custom fall, or edging works cannot be canceled once work has commenced, which is typically within 12 hours of order confirmation.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Refund for Cancellation')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Approved cancellations will receive a full refund processed to the original payment source. Refund timelines vary depending on your bank and payment gateway (typically 5-7 business days).')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('How to Request Cancellation')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Please email us with your order number and request details as quickly as possible. Alternatively, contact us via WhatsApp for swift assistance.')}
                                            </p>
                                        </div>

                                        <div className="contact-info p-4 rounded-3" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Contact Support for Cancellations')}</h3>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone / WhatsApp')}: +91 80562 62626</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default CancellationPolicy;
